import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';
import { CommonMutationCrumbs } from './breadcrumb';

export const AnscNotificationsMutationCrumbs = [
  ...CommonMutationCrumbs,
  {
    name: 'Aggiornamento anagrafe da ANSC',
    path: '/mutazioni/notifiche/ansc',
  },
];

export const DetailAnscNotificationsMutationCrumbs = [
  ...AnscNotificationsMutationCrumbs,
  {
    name: 'Dettaglio Notifiche da ANSC',
    path: '/mutazioni/notifiche/ansc/visualizza/:id/:idNotifica',
  },
];

export const EditAnscNotificationsMutationCrumbs = (
  goBackUrl = '/mutazioni/notifiche/ansc/modifica/:id/:idNotifica'
): Array<BreadcrumbItem> => {
  return [
    ...AnscNotificationsMutationCrumbs,
    {
      name: 'Modifica Notifiche da ANSC',
      path: goBackUrl,
    },
  ];
};

export const BirthAnscNotificationsNonResidentMutationCrumbs = (
  goBackUrl = '/mutazioni/notifiche/ansc/modifica/:id/:idNotifica'
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Registrazione Nascita Non Residenti',
      path: `${goBackUrl}/nascita/non-residenti`,
    },
  ];
};

export const CivilUnionAnscNotificationsResidentMutationCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/unione-civile/residenti`,
    },
  ];
};

export const CivilUnionDetailAnscNotificationsResidentMutationCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...CivilUnionAnscNotificationsResidentMutationCrumbs(goBackUrl),
    {
      name: 'Registrazione Unione Civile',
      path: `${goBackUrl}/unione-civile/residenti/registrazione`,
    },
  ];
};

export const CivilUnionAnscNotificationsNonResidentMutationCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/unione-civile/non-residenti`,
    },
  ];
};

export const CivilUnionDetailAnscNotificationsNonResidentMutationCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...CivilUnionAnscNotificationsNonResidentMutationCrumbs(goBackUrl),
    {
      name: 'Registrazione Unione Civile Non Residenti',
      path: `${goBackUrl}/unione-civile/non-residenti/registrazione`,
    },
  ];
};

export const MarriageAnscNotificationsResidentMutationCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/matrimonio/residenti`,
    },
  ];
};

export const MarriageDetailAnscNotificationsResidentMutationCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...MarriageAnscNotificationsResidentMutationCrumbs(goBackUrl),
    {
      name: 'Registrazione Matrimonio',
      path: `${goBackUrl}/matrimonio/residenti/registrazione`,
    },
  ];
};

export const MarriageAnscNotificationsNonResidentMutationCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/matrimonio/non-residenti`,
    },
  ];
};

export const MarriageDetailAnscNotificationsNonResidentMutationCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...MarriageAnscNotificationsNonResidentMutationCrumbs(goBackUrl),
    {
      name: 'Registrazione Matrimonio Non Residenti',
      path: `${goBackUrl}/matrimonio/non-residenti/registrazione`,
    },
  ];
};

export const DeathAnscNotificationsResidentMutationCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/morte/residenti`,
    },
  ];
};

export const DeathCancellationAnscNotificationsResidentMutationCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...DeathAnscNotificationsResidentMutationCrumbs(goBackUrl),
    {
      name: 'Cancellazione',
      path: `${goBackUrl}/morte/residenti/cancellazione`,
    },
  ];
};

export const DeathAnscNotificationsNonResidentMutationCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/morte/non-residenti`,
    },
  ];
};

export const DeathCancellationAnscNotificationsNonResidentMutationCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...DeathAnscNotificationsNonResidentMutationCrumbs(goBackUrl),
    {
      name: 'Cancellazione',
      path: `${goBackUrl}/morte/non-residenti/cancellazione`,
    },
  ];
};

export const CitizenshipAnscNotificationsMutationCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/cittadinanza/ricerca`,
    },
  ];
};

export const CitizenshipRegistrationAnscNotificationsMutationCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...CitizenshipAnscNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Registrazione',
      path: `${goBackUrl}/cittadinanza/ricerca/registrazione`,
    },
  ];
};

export const FamilyAnscNotificationsMutationCrumbs = (goBackUrl = ''): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia`,
    },
  ];
};

export const FamilyOtherAnscNotificationsMutationCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia/altra`,
    },
  ];
};

export const FamilyMotherAnscNotificationsMutationCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia/madre`,
    },
  ];
};

export const FamilyFatherAnscNotificationsMutationCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia/padre`,
    },
  ];
};

export const FamilyDetailAnscNotificationsMutationCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...FamilyAnscNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/mutazioni/notifiche/ansc/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const FamilyOtherDetailAnscNotificationsMutationCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...FamilyOtherAnscNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/mutazioni/notifiche/ansc/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const FamilyMotherDetailAnscNotificationsMutationCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...FamilyMotherAnscNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/mutazioni/notifiche/ansc/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const FamilyFatherDetailAnscNotificationsMutationCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...FamilyFatherAnscNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/mutazioni/notifiche/ansc/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const CohabitationAnscNotificationsMutationCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...EditAnscNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Ricerca Convivenza',
      path: `${goBackUrl}/convivenza`,
    },
  ];
};

export const CohabitationDetailAnscNotificationsMutationCrumbs = (
  goBackUrl = ''
): Array<BreadcrumbItem> => {
  return [
    ...CohabitationAnscNotificationsMutationCrumbs(goBackUrl),
    {
      name: 'Nascita Convivenza',
      path: '/mutazioni/notifiche/ansc/modifica/:id/:idNotifica/convivenza/nascita',
    },
  ];
};
